import { ValidationSchema } from 'validation-schema-library';

const contactInfoValidationSchema: ValidationSchema = {
  extendedInformation: {
    type: 'object',
    properties: {
      personalPhoneNumber: {
        type: 'string',
        phone: true,
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
              },
            },
            {
              $initializationState: {
                eq: 'FINALIZED',
              },
            },
          ],
        },
      },
      personalEmail: {
        type: 'string',
        email: true,
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
              },
            },
            {
              $initializationState: {
                eq: 'FINALIZED',
              },
            },
          ],
        },
      },
      otherPhoneNumber: {
        type: 'string',
        phone: true,
        regex: {
          value: '^[+]?[0-9\\s\\-\\(\\)]+$',
          message: 'Invalid phone number format',
        },
      },
      additionalContactInfo: {
        type: 'array',
        maxSize: 5,
        forEach: {
          type: 'object',
          _divisible: false,
          properties: {
            type: {
              required: {
                value: true,
                when: [
                  {
                    $initializationState: {
                      eq: 'FINALIZED',
                    },
                  },
                  {
                    $_PERMISSIONS: {
                      ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                    },
                  },
                ],
              },
              maxSize: 128,
            },
            value: {
              required: {
                value: true,
                when: [
                  {
                    $initializationState: {
                      eq: 'FINALIZED',
                    },
                  },
                  {
                    $_PERMISSIONS: {
                      ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                    },
                  },
                ],
              },
              maxSize: 255,
            },
          },
        },
      },
      registrationAddress: {
        type: 'object',
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
              },
            },
            {
              $initializationState: {
                eq: 'FINALIZED',
              },
            },
          ],
        },
        properties: {
          country: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          city: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          addressLine1: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          addressLine2: {
            type: 'string',
            maxSize: 64,
          },
          state: {
            type: 'string',
            maxSize: 64,
          },
          zipCode: {
            type: 'string',
            maxSize: 64,
          },
        },
      },
      homeAddress: {
        type: 'object',
        required: {
          value: true,
          when: [
            {
              $_PERMISSIONS: {
                ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
              },
              $contractType: {
                ne: 'B2B',
              },
            },
            {
              $initializationState: {
                eq: 'FINALIZED',
              },
              $contractType: {
                ne: 'B2B',
              },
            },
          ],
        },
        properties: {
          country: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          city: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          addressLine1: {
            type: 'string',
            required: {
              value: true,
              when: [
                {
                  $_PERMISSIONS: {
                    ct: 'UPDATE_EMPLOYEE_CONTACT_INFORMATION',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
                {
                  $initializationState: {
                    eq: 'FINALIZED',
                  },
                  $contractType: {
                    ne: 'B2B',
                  },
                },
              ],
            },
            maxSize: 64,
          },
          addressLine2: {
            type: 'string',
            maxSize: 64,
          },
          state: {
            type: 'string',
            maxSize: 64,
          },
          zipCode: {
            type: 'string',
            maxSize: 64,
          },
        },
      },
    },
  },
};

const getContactInfoValidationSchema = () => Promise.resolve(contactInfoValidationSchema);

export default getContactInfoValidationSchema;
